const pushRBox = (...commands) => {
    window._taboola.push(commands);
};

export default pushRBox;
